/** Just the fields the label reads, so a caller holding a partial event — or a
 *  row rendering one from the manifest — can ask without a full CalendarEvent. */
export interface EventTimeFields {
  startAt: string;
  isAllDay?: boolean;
}

/**
 * "Today · 3:00 PM" / "Sep 16 · 9:30 AM" / "Sep 20 · All day".
 *
 * Today is named rather than dated because a meeting chip is read at a glance
 * and the date carries nothing the reader does not already know.
 *
 * Local time throughout: `toDateString` compares calendar days in the viewer's
 * zone, so 23:30 tonight and 00:30 tomorrow read as different days despite
 * being an hour apart.
 */
export function formatEventTime(event: EventTimeFields): string {
  const start = new Date(event.startAt);
  const timeLabel = event.isAllDay
    ? 'All day'
    : start.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  const isToday = start.toDateString() === new Date().toDateString();
  if (isToday) return `Today · ${timeLabel}`;
  const dateLabel = start.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  return `${dateLabel} · ${timeLabel}`;
}
